import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	FreudButtonModule,
	FreudTooltipModule,
	FreudTypographyModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { ReceiptButtonModule } from 'app/appointments/receipt-button/receipt-button.module';
import { AccordionModule } from 'shared/components/accordion/accordion.module';

import { AppointmentDetailsPaymentDataComponent } from './appointment-details-payment-data.component';

@NgModule({
	declarations: [AppointmentDetailsPaymentDataComponent],
	exports: [AppointmentDetailsPaymentDataComponent],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FreudTypographyModule,
		AccordionModule,
		FreudTooltipModule,
		FreudButtonModule,
		ReceiptButtonModule,
	],
})
export class AppointmentDetailsPaymentDataModule {}
